import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClone } from "@fortawesome/free-solid-svg-icons";

import ReadOnlyTable from "../../../attributes/read-only-table";
import Modal from "../../../modal";

const DuplicateProduct = (props) => {
    const [showModal, setShowModal] = useState(false);
    const openModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowModal(true);
    };
    const closeModal = () => {
        setShowModal(false);
    };

    return (
        <div className="duplicate-product">
            <Modal show={showModal} onClose={closeModal}>
                <ReadOnlyTable referenceProducts={props.duplicateProducts} />
            </Modal>
            <button className="button -small" onClick={openModal}>
                <FontAwesomeIcon icon={faClone} />
            </button>
        </div>
    );
};

export default DuplicateProduct;
